<template>
  <section>
    <el-row :gutter="10">
      <el-col :span="8">
        <el-card>
          <el-row class="card-title">
            <el-col :span="9"><span class="statics-title">诉求区域情况</span></el-col>
            <el-col :span="15" style="text-align:right">

              <el-radio-group v-model="areaStaticsType"  @change="areaStaticsChange" size="mini">
                <el-radio-button label="opinion">诉求意见</el-radio-button>
                <el-radio-button label="pay">保障支付</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row class="card-title">
            <el-col :span="24" style="text-align: left">
              <el-date-picker
                size="mini"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                v-model="areaTime"
                @change="areaTimeChange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
          </el-row>
          <ve-pie
            style="width:100%"
            :data="areaStaticsData"
            :settings="areaStaticsSetting"></ve-pie>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card>
          <el-row class="card-title">
            <el-col :span="11"><span class="statics-title">诉求登记走势图</span></el-col>
            <el-col :span="13" style="text-align:right">
              <el-radio-group v-model="appealTime"  @change="appealTimeChange" size="mini">
                <el-radio-button label="week">周</el-radio-button>
                <el-radio-button label="month">月</el-radio-button>
                <el-radio-button label="year">年</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
        <ve-line
          width="100%"
          :data="appealTimeData"
          :settings="appealTimeSettings"
          :extend="lineExtend"></ve-line>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top: 10px">
      <el-col :span="12">
        <el-card>
          <el-row class="card-title">
            <el-col :span="12"><span class="statics-title">诉求意见</span></el-col>
            <el-col :span="12" style="text-align:right">
              <el-date-picker
                size="mini"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                v-model="opinionTime"
                @change="opinionTimeChange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
          </el-row>
          <div id="opinion-content" style="width:100%;overflow: scroll">
          <ve-histogram
            style="width: 1500px;"
            :data="opinionData"
            :extend="opinionExtend"
            :settings="opinionDataConfig.setting"></ve-histogram>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <el-row class="card-title">
            <el-col :span="12"><span class="statics-title">保障支付</span></el-col>
            <el-col :span="12" style="text-align:right">
              <el-date-picker
                size="mini"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                v-model="payTime"
                @change="payTimeChange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
          </el-row>
          <ve-histogram
            style="width:100%"
            :data="payData"
            :settings="payDataConfig.setting"></ve-histogram>
        </el-card>
      </el-col>
    </el-row>
  </section>
</template>
<script>
  import VeLine from 'v-charts/lib/line.common'
  import VePie from 'v-charts/lib/pie.common'
  import VeHistogram from 'v-charts/lib/histogram.common'
  import { staticsAreaAppeal, staticsAppealTime, staticsAppealStatus } from '@/api/restapi.js'
  export default {
    components: { VeLine, VeHistogram, VePie },
    data () {
      return {
        areaStaticsType: 'opinion',
        appealTime: 'month',
        areaTime: [],
        opinionTime: [],
        payTime: [],
        areaStaticsData: {
          columns: ['key', 'value'],
          rows: []
        },
        areaStaticsSetting: {
          itemStyle: {
            normal: {
              label: { show: true, position: 'inner', formatter: '{c}' }
            }
          }
        },
        appealTimeData: {
          columns: ['time', 'opinion', 'pay'],
          rows: []
        },
        appealTimeSettings: {
          labelMap: {
            opinion: '诉求意见',
            pay: '保障支付'
          },
          metrics: ['opinion', 'pay'],
          dimension: ['time']
        },
        lineExtend: {
          series: {
            smooth: false
          }
        },
        opinionData: {
          columns: ['appealType', 'wait', 'distribution', 'unhandle', 'finish'],
          rows: []
        },
        opinionExtend: {
          legend: {
            left: 0
          }
        },
        opinionDataConfig: {
          setting: {
            labelMap: {
              wait: '待处理',
              distribution: '已分配',
              unhandle: '不处理',
              finish: '已完成'
            },
            itemStyle: {
              normal: {
                label: { show: true, position: 'top', formatter: '{c}' }
              }
            },
            metrics: ['wait', 'distribution', 'unhandle', 'finish'],
            dimension: ['appealType']
          }
        },
        payData: {
          columns: ['appealType', 'wait', 'distribution', 'unhandle', 'finish'],
          rows: []
        },
        payDataConfig: {
          setting: {
            labelMap: {
              wait: '待处理',
              distribution: '已分配',
              unhandle: '不处理',
              finish: '已完成'
            },
            itemStyle: {
              normal: {
                label: { show: true, position: 'top', formatter: '{c}' }
              }
            },
            metrics: ['wait', 'distribution', 'unhandle', 'finish'],
            dimension: ['appealType']
          }
        }
      }
    },
    mounted () {
      this.getAreaAppeal('','')
      this.getAreaAppealTime()
      this.getAppealStatus('opinion','','')
      this.getAppealStatus('pay','','')
      this.scrollFunction()
    },
    methods: {
      scrollFunction () {
        this.domObj = document.getElementById('opinion-content') // 通过id获取要设置的div
        if (this.domObj.attachEvent) { // IE
          this.domObj.attachEvent('onmousewheel', this.mouseScroll)
        } else if (this.domObj.addEventListener) {
          this.domObj.addEventListener('DOMMouseScroll', this.mouseScroll, false)
        }
        this.domObj.onmousewheel = this.domObj.onmousewheel = this.mouseScroll
      },
      mouseScroll(event) { // google 浏览器下
        let detail = event.wheelDelta || event.detail
        let moveForwardStep = -1
        let moveBackStep = 1
        let step = 0
        step = detail > 0 ? moveForwardStep * 100 : moveBackStep * 100
        event.preventDefault() // 阻止浏览器默认事件
        this.domObj.scrollLeft = this.domObj.scrollLeft + step
      },
      areaTimeChange (val) {
        let startTime = ''
        let endTime = ''
        if (val) {
          if (val[0]){
            startTime = val[0] + ' 00:00:00'
          }
          if (val[1]) {
            endTime = val[1] + ' 23:59:59'
          }
        }
        this.getAreaAppeal(startTime,endTime)
      },
      opinionTimeChange (val) {
        let startTime = ''
        let endTime = ''
        if (val) {
          if (val[0]){
            startTime = val[0] + ' 00:00:00'
          }
          if (val[1]) {
            endTime = val[1] + ' 23:59:59'
          }
        }
        this.getAppealStatus('opinion', startTime, endTime)
      },
      payTimeChange (val) {
        let startTime = ''
        let endTime = ''
        if (val) {
          if (val[0]){
            startTime = val[0] + ' 00:00:00'
          }
          if (val[1]) {
            endTime = val[1] + ' 23:59:59'
          }
        }
        this.getAppealStatus('pay',startTime, endTime)
      },
      areaStaticsChange() {
        let startTime = ''
        let endTime = ''
        if (this.areaTime) {
          if (this.areaTime[0]){
            startTime = this.areaTime[0] + ' 00:00:00'
          }
          if (this.areaTime[1]) {
            endTime = this.areaTime[1] + ' 23:59:59'
          }
        }
        this.getAreaAppeal(startTime,endTime)
      },
      appealTimeChange () {
        this.getAreaAppealTime()
      },
      getAreaAppeal (startTime,endTime) {
        staticsAreaAppeal(this.areaStaticsType,startTime,endTime).then(res => {
          if (res.data.code === 0) {
            this.areaStaticsData.rows = res.data.data
          }
        })
      },
      getAreaAppealTime () {
        staticsAppealTime(this.appealTime).then(res => {
          if (res.data.code === 0) {
            this.appealTimeData.rows = res.data.data
          }
        })
      },
      getAppealStatus(type,startTime,endTime) {
        staticsAppealStatus(type,startTime,endTime).then(res => {
          if (res.data.code === 0) {
            if (type==='opinion') {
              this.opinionData.rows = res.data.data
            }else {
              this.payData.rows = res.data.data
            }
          }
        })
      }
    }
  }
</script>
<style scoped>
  .card-title {
    height: 30px;
    line-height: 30px;
  }
  .statics-title {
    border-left-style: solid;
    border-left-color: #7CA9F2;
    border-left-width: 5px;
    padding: 3px;
    font-size: 14px;
  }
  .el-card {
    height: 400px;
  }
  .el-card >>> .el-card__body {
    padding: 10px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Statics.vue